/**
 @name: 记工记账接口列表
 @description:
 @author: 徐朝成 xcc614@qq.com
 @time: 2021-09-27 12:12:50
 **/
import request from '@/http'

export const api = {
  getProjectPage: (data) => request.post(`/settleProject/getProjectPage`,data),// 记工项目列表
  addTenderMoney: (data) => request.post(`/settleProject/add`,data),// 记工项目添加
  delTenderMoney: (data) => request.delete(`/settleProject/delete/${data.no}/${data.phoneNumber}/${data.code}`),// 记工项目删除
  workRecords: (data) => request.post(`/settlePointWork/workRecords`,data),// 点工记账流水列表
  workRecordDetail: ({no,type}) => request.get(`/settlePointWork/detail/${no}/${type}`),// 点工记账流水详情
  workRecordDel: (no) => request.delete(`/settlePointWork/delete/${no}`),// 点工记账流水删除
  workRecordDelBZ: (no) => request.delete(`/settlePointWork/deleteBz/${no}`),// 点工记账流水删除-班组
  workRecordAdd: (data) => request.post(`/settlePointWork/add`,data),// 点工记账流水添加
  workWrapDetail: ({no,type}) => request.get(`/settleWrapWork/detail/${no}/${type}`),// 包工记账流水详情
  workWrapdsDel: (no) => request.delete(`/settleWrapWork/delete/${no}`),// 包工记账流水删除
  workWrapdsDelBZ: (no) => request.delete(`/settleWrapWork/deleteBz/${no}`),// 包工记账流水删除-班组
  workWrapAdd: (data) => request.post(`/settleWrapWork/add`,data),// 包工记账流水添加
  PointSalary: (no) => request.post(`/settlePointSalaryStandard/detail/${no}`),// 点工工资标准列表
  PointSalaryDel: (no) => request.delete(`/settlePointSalaryStandard/delete/${no}`),// 点工工资标准删除
  PointSalaryAdd: (data) => request.post(`/settlePointSalaryStandard/add`,data),// 点工工资标准添加
  sendCode: (data) => request.get(`/team/common/sendCode?telPhone=${data}`),// 发送验证码
  getWorkStatistics: (data) => request.post(`/settleProject/getWorkStatistics`,data),// 获取项目记工统计列表
  getLatestSalaryStandard: (data) => request.get(`/settlePointSalaryStandard/getLatestSalaryStandard?projectNo=${data.projectNo}&type=${data.type}`),// 获取当前项目工资标准
  settleWorkerAdd: (data) => request.post(`/settleWorker/add`,data),// 工友管理 添加
  settleWorkerAddMy: (type) => request.get(`/settleWorker/addMySelf/${type}`),// 工友管理 添加自己
  settleWorkeDel: (no) => request.delete(`/settleWorker/delete/${no}`),// 工友管理 删除
  settleWorkerPage: (data) => request.post(`/settleWorker/getWorkerPage`,data),// 工友管理 列表
  getWorkerList:(type)=>request.get(`/settleWorker/getWorkerList/${type}`) // 获取工人列表（不分页）
}
